module.exports = __webpack_public_path__ + "assets/img/10.75116fad.jpg";